<script setup>
import { ref, reactive } from "vue";
import TreatmentPlant from "./treatmentPlant.vue";
import SupplyPlant from "./supplyPlant.vue";
import { EFFLUENT_TREE } from "@/constants";
import { ElMessage } from "element-plus";

// 页面title
const title = ref("内控标准");

// 是否点击了标准
const isEmpty = ref(true);

const treatRef = ref(null);

const supplyRef = ref(null);

// 页面参数
const pageParams = reactive({
  type: 0,
});

// 树点击事件
const handleNodeClick = (data) => {
  if ([1, 2, 3, 4, 5, 6].includes(data.type)) {
    isEmpty.value = false;
    pageParams.type = data.type;
    if (data.type == 6) {
      setTimeout(() => {
        supplyRef.value.getStandardInfo(data.type);
      }, 1);
      return;
    }
    // 保证purRef对象有值才执行
    setTimeout(() => {
      treatRef.value.getStandardInfo(data.type);
    }, 1);
  } else {
    isEmpty.value = true;
    ElMessage.warning("请选择具体执行标准!");
  }
};

const handleSave = () => {
  if (pageParams.type == 6) {
    supplyRef.value?.formSubmit(pageParams.type);
  } else {
    treatRef.value?.formSubmit(pageParams.type);
  }
};
</script>

<template>
  <zh-table-page v-bind="{ title }">
    <template #header-btn>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </template>
    <template #search></template>
    <template #left>
      <el-tree
        :data="EFFLUENT_TREE"
        node-key="id"
        :expand-on-click-node="false"
        ref="treeRef"
        default-expand-all
        @node-click="handleNodeClick"
        highlight-current
      >
        <template #default="{ node }">
          <span class="custom-tree-node">
            <span>
              {{ node.label }}
            </span>
          </span>
        </template>
      </el-tree>
    </template>
    <template #table>
      <el-empty
        v-show="isEmpty"
        :image="require('@/assets/images/none.png')"
        description="请选择具体执行标准"
        style="height: 100%"
        :image-size="200"
      />
      <div v-show="!isEmpty">
        <!-- 供水厂内控 -->
        <div v-show="pageParams.type === 6">
          <supply-plant ref="supplyRef" />
        </div>
        <!-- 净水厂内控标准 -->
        <div v-show="[1, 2, 3, 4, 5].includes(pageParams.type)">
          <treatment-plant ref="treatRef" />
        </div>
      </div>
    </template>
  </zh-table-page>
</template>

<style lang="scss" scoped></style>
